









import { AppModule } from '@/store/modules/app'
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component({
    name: "gift-options-button"
})
export default class GiftOptionsButton extends Vue {
    @Prop({}) private isMobile: boolean | undefined

    goToGiftoptions(): void {
        AppModule.SetShowGiftOptions(true)
    }

    get allStepsCompleted(): boolean {
        let steps = AppModule.steps
        for (let i = 1; i < steps.length - 1; i++) {
            if (steps[i].completed === false) {
                return false
            }
        }
        return true
    }
}
